import axios from 'axios';
import { config } from '../config';

const API_URL = config.BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const getMainShortnames = async (q = '') => {
  const response = await api.get('/api/shortnames/main', {
    params: { q }
  });
  return response.data;
};

export const updateMainShortname = async (id, shortName) => {
  const response = await api.put(`/api/shortnames/main/${id}`, {
    short_name: shortName
  });
  return response.data;
};

export const deleteMainShortname = async (id) => {
  const response = await api.delete(`/api/shortnames/main/${id}`);
  return response.data;
};

export const getBranchShortnames = async (q = '') => {
  const response = await api.get('/api/shortnames/branch', {
    params: { q }
  });
  return response.data;
};

export const updateBranchShortname = async (id, shortName) => {
  const response = await api.put(`/api/shortnames/branch/${id}`, {
    short_name: shortName
  });
  return response.data;
};

export const deleteBranchShortname = async (id) => {
  const response = await api.delete(`/api/shortnames/branch/${id}`);
  return response.data;
};

export const generateMainShortname = async (id) => {
  const response = await api.post(`/api/shortnames/main/${id}/generate`);
  return response.data;
};

export const generateBranchShortname = async (id) => {
  const response = await api.post(`/api/shortnames/branch/${id}/generate`);
  return response.data;
};

export const generateBatchMainShortnames = async () => {
  const response = await api.post('/api/shortnames/main/generate-batch', {}, { timeout: 600000 });
  return response.data;
};

export const generateBatchBranchShortnames = async () => {
  const response = await api.post('/api/shortnames/branch/generate-batch', {}, { timeout: 600000 });
  return response.data;
};

export const getAiLogs = async (params = {}) => {
  const response = await api.get('/api/shortnames/ai-logs', { params });
  return response.data;
};

export const getAiPrompts = async () => {
  const response = await api.get('/api/shortnames/ai-prompts');
  return response.data;
};

export const updateAiPrompt = async (key, promptText) => {
  const response = await api.put(`/api/shortnames/ai-prompts/${key}`, { prompt_text: promptText });
  return response.data;
};

const shortnameService = {
  getMainShortnames,
  updateMainShortname,
  deleteMainShortname,
  getBranchShortnames,
  updateBranchShortname,
  deleteBranchShortname,
  generateMainShortname,
  generateBranchShortname,
  generateBatchMainShortnames,
  generateBatchBranchShortnames,
  getAiLogs,
  getAiPrompts,
  updateAiPrompt,
};

export default shortnameService;
